import {Component, OnDestroy, OnInit} from '@angular/core';
import {AngularEditorConfig} from '@kolkov/angular-editor';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {interval, ReplaySubject} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Router} from '@angular/router';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {delay, first, startWith, takeUntil, tap} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {SettlementTemplateService} from '../../../shared/services/settlement-template.service';
import {SettlementTemplate} from '../../../shared/interface/settlement-template';
import moment from 'moment';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss']
})
export class TemplateComponent implements OnInit, OnDestroy {
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '300px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Wprowadź treść email..',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      {class: 'arial', name: 'Arial'},
      {class: 'times-new-roman', name: 'Times New Roman'},
      {class: 'calibri', name: 'Calibri'},
      {class: 'comic-sans-ms', name: 'Comic Sans MS'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      [],
      [
        'insertVideo',
      ]
    ]
  };

  templateForm: FormGroup;
  contentControl: FormControl;
  companyControl: FormControl;
  billingMonthControl: FormControl;
  copyBillingMonthControl: FormControl;
  typeOfSettlementControl: FormControl;
  currentTemplateObject: SettlementTemplate;
  copyTemplateObject: SettlementTemplate;
  processingRequest = false;
  errors: any = {};
  editor = false;
  temp = '## Dowolna treść {{ KWOTA }} ##';
  buttonValid = false;
  copyDate = moment();

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private router: Router,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private settlementTemplateService: SettlementTemplateService,
  ) {
    const date = moment();
    date.subtract(1, 'month');
    this.billingMonthControl = fb.control(date, [Validators.required]);
    this.copyBillingMonthControl = fb.control(date);

    this.templateForm = this.fb.group({
      billingMonth:  this.billingMonthControl,
      content: this.contentControl = fb.control('',  [Validators.required]),
      company: this.companyControl = fb.control('', [Validators.required]),
      typeOfSettlement: this.typeOfSettlementControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  download(): void{
    this.buttonValid = false;
    this.initialize();
  }
  initialize(): void {
    // this.editor = true;
    // this.settlementTemplateService.getCurrent({
    //   billingMonth: this.billingMonthControl.value.format('YYYY-MM'),
    //   company: this.companyControl.value,
    //   typeOfSettlement: this.typeOfSettlementControl.value
    // })
    //   .subscribe((settlementTemplate: SettlementTemplate) => {
    //     if (settlementTemplate) {
    //       this.currentTemplateObject = settlementTemplate;
    //       this.templateForm.reset({
    //         uuid: this.currentTemplateObject.uuid,
    //         content: this.currentTemplateObject.content,
    //         company: this.currentTemplateObject.company?.id,
    //         typeOfSettlement: this.currentTemplateObject.typeOfSettlement?.id,
    //         billingMonth: this.billingMonthControl.value
    //       });
    //     }
    //   }, (error: HttpErrorResponse) => {
    //     this.templateForm.reset({
    //       uuid: '',
    //       content: '',
    //       company: this.companyControl.value,
    //       typeOfSettlement: this.typeOfSettlementControl.value,
    //       billingMonth: this.billingMonthControl.value
    //     });
    //     this.snackBar.open(`Brak szablonu dla miesiąca: ${this.billingMonthControl.value.format('YYYY-MM')}`, null, {
    //       duration: 5000,
    //     });
    //     this.currentTemplateObject = null;
    //   });
  }

  save(): void {
    this.buttonValid = true;
    this.processingRequest = true;
    this.settlementTemplateService.sendForm(
      this.templateForm.value, this.currentTemplateObject ? this.currentTemplateObject.uuid : null
    )
      .pipe(
        first()
      )
      .subscribe(() => {
        this.snackBar.open('Pomyślnie zapiszano szablon', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.initialize();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.templateForm, this.errors);
        }
      });
  }
  copy(): void {
  //   const activeToDate = moment(this.billingMonthControl.value);
  //   activeToDate.subtract(1, 'month');
  //   this.copyBillingMonthControl.setValue(activeToDate);
  //
  //   this.settlementTemplateService.getCurrent({
  //     billingMonth: this.copyBillingMonthControl.value.format('YYYY-MM'),
  //     company: this.companyControl.value,
  //     typeOfSettlement: this.typeOfSettlementControl.value
  //   })
  //     .pipe()
  //     .subscribe((copySettlementTemplate) => {
  //       if (copySettlementTemplate) {
  //         this.copyTemplateObject = copySettlementTemplate;
  //         this.templateForm.reset({
  //           content: this.copyTemplateObject.content,
  //           company: this.companyControl.value,
  //           typeOfSettlement: this.typeOfSettlementControl.value,
  //           billingMonth: this.billingMonthControl.value
  //         });
  //       }
  //     }, (error: HttpErrorResponse) => {
  //       this.snackBar.open(`Brak szablonu dla miesiąca: ${this.copyBillingMonthControl.value.format('YYYY-MM')}`, null, {
  //         duration: 5000,
  //       });
  //     });
  //
  }

}
